<template>
  <div>
    <index-navbar />
    <main class="profile-page">
      <section class="relative block h-500-px">
        <div class="absolute top-0 w-full h-full bg-center bg-cover" style="
            background-image: url('https://i.imgur.com/3H0VuON.jpeg');
          ">
          <span id="blackOverlay" class="w-full h-full absolute opacity-50 bg-black"></span>
        </div>
        <div class="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px"
          style="transform: translateZ(0);">
          <svg class="absolute bottom-0 overflow-hidden" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none"
            version="1.1" viewBox="0 0 2560 100" x="0" y="0">
            <polygon class="text-blueGray-200 fill-current" points="2560 0 2560 100 0 100"></polygon>
          </svg>
        </div>
      </section>
      <section class="relative py-16 bg-blueGray-200">
        <div class="container mx-auto px-4">
          <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-xl rounded-lg -mt-64">
            <div class="px-6">
              <div class="flex flex-wrap justify-center">
                <div class="w-full lg:w-3/12 px-4 lg:order-2 flex justify-center">

                </div>
                <div class="w-full lg:w-12/12 px-4 lg:order-3 lg:text-center lg:self-center">
                  <div class="px-3 mt-32 py-5 sm:mt-0 text-center "> <!-- Añadí text-center aquí -->
                    <h1 style="font-size: 36px;">Términos y condiciones</h1>
                  </div>
                </div>
                <!--  <div class="w-full lg:w-4/12 px-4 lg:order-1">
                  <div class="flex justify-center py-4 lg:pt-4 pt-8">
                    <div class="mr-4 p-3 text-center">
                      <span
                        class="text-xl font-bold block uppercase tracking-wide text-blueGray-600"
                      >
                        22
                      </span>
                      <span class="text-sm text-blueGray-400">Friends</span>
                    </div>
                    <div class="mr-4 p-3 text-center">
                      <span
                        class="text-xl font-bold block uppercase tracking-wide text-blueGray-600"
                      >
                        10
                      </span>
                      <span class="text-sm text-blueGray-400">Photos</span>
                    </div>
                    <div class="lg:mr-4 p-3 text-center">
                      <span
                        class="text-xl font-bold block uppercase tracking-wide text-blueGray-600"
                      >
                        89
                      </span>
                      <span class="text-sm text-blueGray-400">Comments</span>
                    </div>
                  </div>
                </div> -->
              </div>
              <!--   <div class="text-center mt-12">
                <h3
                  class="text-4xl font-semibold leading-normal mb-2 text-blueGray-700 mb-2"
                >
                  Jenna Stones
                </h3>
                <div
                  class="text-sm leading-normal mt-0 mb-2 text-blueGray-400 font-bold uppercase"
                >
                  <i
                    class="fas fa-map-marker-alt mr-2 text-lg text-blueGray-400"
                  ></i>
                  Los Angeles, California
                </div>
                <div class="mb-2 text-blueGray-600 mt-10">
                  <i
                    class="fas fa-briefcase mr-2 text-lg text-blueGray-400"
                  ></i>
                  Solution Manager - Creative Tim Officer
                </div>
                <div class="mb-2 text-blueGray-600">
                  <i
                    class="fas fa-university mr-2 text-lg text-blueGray-400"
                  ></i>
                  University of Computer Science
                </div>
              </div> -->
              <div class="mt-10 py-10 border-t border-blueGray-200 text-center">
  <div class="flex flex-wrap justify-center">
    <div class="w-full lg:w-9/12 px-4">
      <p class="mb-4 text-lg leading-relaxed text-blueGray-700 text-left">
        <strong>Aviso de Privacidad</strong><br><br>
        En términos de la <strong>LEY FEDERAL DE PROTECCIÓN DE DATOS PERSONALES EN POSESIÓN DE LOS PARTICULARES (LFPDPPP)</strong>, CREATIVO SOCIAL MARKETING, en lo sucesivo “LA EMPRESA”, pone a su disposición el presente aviso de privacidad, previo al tratamiento de sus datos personales, de conformidad con lo siguiente:<br><br>

        <strong>I. IDENTIDAD Y DOMICILIO DE “LA EMPRESA”</strong><br>
        CREATIVO SOCIAL MARKETING es responsable del tratamiento (uso) de sus datos personales, es una empresa debidamente constituida y legalmente existente conforme a las leyes de los Estados Unidos Mexicanos, con domicilio para efectos del presente aviso de privacidad en Calle Tuxpan número 303, Colonia Universal, C.P. 34165. Número telefónico de contacto: 6181788315.<br><br>

        Toda comunicación deberá dirigirse al Departamento de Datos Personales, el cual ha sido designado como responsable para el trámite de solicitudes y fomento a la protección de Datos Personales, en términos del Artículo 30 de la Ley.<br><br>

        <strong>II. DATOS PERSONALES QUE OBTENEMOS Y DE PROCEDENCIA</strong><br>
        Datos personales que recabamos tratándose de persona moral:<br>
        • Información del cliente (razón social, correo electrónico, dirección, comprobante de domicilio, teléfono).<br>
        • Documentación de identidad (acta constitutiva, folio de registro ante registro público de la propiedad y comercio).<br>
        • Información fiscal (cédula de identificación fiscal, dirección de facturación).<br>
        • Datos financieros: información de cuentas bancarias, formas de pago.<br><br>

        Datos personales que recabamos tratándose de persona física:<br>
        • Información del contacto (Nombre completo, correo electrónico, dirección, comprobante de domicilio, teléfono, celular).<br>
        • Documentación de identidad (Credencial de elector, pasaporte, licencia de manejo, cartilla o cédula profesional).<br>
        • Información fiscal (Cédula de identificación fiscal, dirección de facturación).<br><br>

        Datos personales sensibles, patrimoniales o financieros que podríamos llegar a recabar:<br>
        • Datos financieros: información de cuentas bancarias, formas de pago.<br><br>

        <strong>III. FINALIDAD DEL TRATAMIENTO DE LOS DATOS PERSONALES</strong><br>
        “LA EMPRESA” se obliga a hacer uso correcto de sus datos personales, incluyendo los datos personales sensibles que en su caso se lleguen a recopilar de conformidad con los principios de la Ley Federal de Protección de Datos Personales en posesión de los particulares: licitud, consentimiento, información, calidad, finalidad, lealtad, proporcionalidad y responsabilidad. El objeto o fin de la obtención, uso y almacenamiento de los datos personales del titular se desglosa de la siguiente manera:<br>
        1. Brindarle asesoría jurídica.<br>
        2. Verificar la información que nos proporciona.<br>
        3. Para uso interno de “LA EMPRESA”, así como dar contestación a sus dudas o comentarios derivados de la prestación de servicios.<br>
        4. Para la promoción de los productos y servicios que ofrece “LA EMPRESA” o, en su caso, invitaciones para alguno de nuestros eventos.<br>
        5. Integrar su expediente como cliente.<br>
        6. Proveer servicios y productos requeridos e informar sobre nuevos productos o servicios que estén relacionados con lo contratado o adquirido por “El Titular”.<br>
        7. Informar sobre cambios en nuestros servicios, evaluar la calidad en el servicio y productos.<br>
        8. La identificación, tecnologías de la información, operación, administración, mercadotecnia, comercialización y otros fines análogos y lícitos conforme a lo dispuesto por la Ley, derivados de los servicios contratados por “El Titular”.<br><br>

        Los datos sensibles se recabarán para las siguientes finalidades:<br>
        • Para tener los antecedentes necesarios con el objeto de poder prestar la atención adecuada.<br><br>

        Al leer y aceptar el presente Aviso de Privacidad, doy mi consentimiento para el tratamiento de mis datos personales sensibles, para las finalidades necesarias para la prestación de servicios con el Responsable.<br><br>

        Para las finalidades señaladas anteriormente, podemos recabar sus datos personales de distintas formas:<br>
        • Cuando libremente usted nos los proporciona de manera voluntaria.<br>
        • Por medio de nuestra página web.<br>
        • Por vía telefónica.<br>
        • Cuando obtenemos información a través de otras fuentes de acceso público que están permitidas por la ley (directorios telefónicos, correo electrónico, sitios web, y demás afines).<br><br>

        Se hace de su conocimiento que en nuestras instalaciones se cuenta con un sistema de cámaras de vigilancia con circuito cerrado, el cual se encuentra activo las 24 horas del día, el cual nos permite mantenernos informados y contar con un control de acceso sobre los visitantes que acceden a las instalaciones y garantizar la seguridad del personal, clientes y visitantes.<br><br>

        Toda la información personal y agregada que se obtenga de “El Titular” constituirá una base de datos, propiedad de “LA EMPRESA”, información que se almacena para protegerla y evitar su pérdida, uso indebido, alteración, o que la misma pueda ser interceptada por terceros. “El Cliente” autoriza expresamente por este medio a “LA EMPRESA” a compartir la información personal proporcionada con alguna Autoridad que le requiera por escrito y en términos de ley.<br><br>

        <strong>IV. ENLACES A OTROS SITIOS WEB</strong><br>
        Nuestro sitio Web puede contener, para su conveniencia, enlaces a diferentes sitios Web. “LA EMPRESA” no es responsable de dichos sitios Web, por lo que no garantiza, ni se hace responsable del contenido encontrado en estos. Lo invitamos a que lea cuidadosamente el Aviso de Privacidad de cada uno de los sitios en Internet que visita.<br><br>

        <strong>V. LAS OPCIONES Y MEDIOS PARA LIMITAR EL USO O DIVULGACIÓN DE LOS DATOS PERSONALES</strong><br>
        En el momento en que “LA EMPRESA” recabe sus datos personales, El Titular de los mismos podrá limitar su uso o divulgación, manifestando su oposición en relación a finalidades no necesarias, lo cual tendrá que manifestar al momento de solicitarle sus datos personales, y señalar cuáles no está dispuesto a facilitar al responsable.<br><br>

        De igual manera, si El Titular no manifiesta su inconformidad en el momento en el que se le estén recabando sus datos personales, “LA EMPRESA” recabará los datos que considere suficientes para llevar a cabo el servicio contratado.<br><br>

        <strong>VI. MEDIOS PARA EJERCER SU OPOSICIÓN PARA EL TRATAMIENTO DE DATOS PARA FINALIDADES NO NECESARIAS</strong><br>
        Usted puede manifestar su oposición para el tratamiento de sus datos para finalidades no necesarias generando un escrito libre en donde manifieste qué datos no está de acuerdo en facilitar al responsable. El escrito irá dirigido al correo de contacto del área destinada al tratamiento de datos personales, siendo este <a href="mailto:adr939200@gmail.com" class="text-emerald-500">adr939200@gmail.com</a>. El mencionado escrito deberá cumplir con los siguientes requerimientos:<br>
        • Nombre completo del titular de los datos personales.<br>
        • Puntualizar los datos que no desea facilitar al responsable.<br>
        • Dar una breve explicación del por qué cree innecesario facilitar esos datos al responsable.<br>
        • Anexar al escrito un documento oficial de identificación del titular de los datos personales.<br><br>

        <strong>VII. LOS MEDIOS PARA EJERCER LOS DERECHOS DE ACCESO, RECTIFICACIÓN, CANCELACIÓN U OPOSICIÓN</strong><br>
        “El Titular” podrá solicitar a “LA EMPRESA”, en cualquier momento, el acceso, la rectificación, la cancelación u oposición respecto a los datos personales que le conciernen. Los mecanismos que se han implementado para el ejercicio de dichos derechos son a través de la presentación de la solicitud respectiva a nuestro Departamento de Datos Personales, ya sea personalmente en la dirección del mismo o enviando un correo electrónico al señalado previamente. En donde, después de recibida su solicitud, “LA EMPRESA” cuenta con un término de 20 días hábiles para darle contestación y hacerle saber si su solicitud es procedente o no. Si esta llegase a proceder, el responsable contará con un plazo de 15 días hábiles para hacer efectiva la petición por parte del titular de los datos personales.<br><br>

        <strong>VIII. TRANSFERENCIAS DE DATOS QUE SE EFECTÚEN</strong><br>
        “LA EMPRESA” se compromete a no transferir su información personal a terceros sin su consentimiento, salvo las excepciones previstas en el artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, así como realizar esta transferencia en los términos que fija esa Ley.<br><br>

        En caso de que “LA EMPRESA” llegare a transferir tus datos personales a terceros proveedores de servicios para el cumplimiento de las obligaciones legales, contables, regulatorias o contractuales a cargo de CREATIVO SOCIAL MARKETING o de cualquiera de sus empresas afiliadas en México o en el extranjero, con el fin de llevar a cabo las finalidades del tratamiento establecidas en el presente aviso de privacidad, lo hará previa celebración de convenios de confidencialidad y, siempre y cuando (1) el proveedor o persona a quien se le transmitan acepte someter el tratamiento de los datos personales al presente aviso de privacidad y, (2) no se trate de alguno de los supuestos establecidos en el artículo 37 de la Ley. Si usted no manifiesta su oposición para que sus datos personales sean transferidos a terceros, se entenderá que ha otorgado a CREATIVO SOCIAL MARKETING su consentimiento para ello.<br><br>

        <strong>IX. MEDIDAS DE SEGURIDAD PARA PROTECCIÓN DE DATOS PERSONALES</strong><br>
        La empresa ha adoptado y mantiene las medidas de seguridad administrativas, técnicas y físicas necesarias y a su alcance para proteger los datos personales que libremente nos ha proporcionado.<br><br>

        <strong>X. MODIFICACIONES AL AVISO DE PRIVACIDAD</strong><br>
        El presente aviso de privacidad podrá ser modificado o actualizado unilateralmente por “LA EMPRESA”, informándole a “El Titular” de dichos cambios a través de los siguientes medios: (I) anuncios visibles en nuestros establecimientos o centros de atención a clientes; (II) trípticos o folletos disponibles en nuestros establecimientos o centros de atención a clientes; (III) en nuestra página de Internet; (IV) o se las haremos llegar al último correo electrónico que nos haya proporcionado.<br><br>

        Si usted tiene alguna duda sobre el presente aviso de privacidad, puede ponerse en contacto con nosotros a los teléfonos y/o correo electrónico señalados en el apartado primero denominado “I. IDENTIDAD Y DOMICILIO DE “LA EMPRESA”, donde recibirá la atención solicitada.<br><br>

        <strong>Fecha de última actualización:</strong> 30 de enero de 2025.
      </p>
      
    </div>
  </div>
</div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <footer-component />
  </div>
</template>
<script>
import Navbar from "@/components/Navbars/AuthNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";

import team2 from "@/assets/img/team-2-800x800.jpg";

export default {
  data() {
    return {
      team2,
    };
  },
  components: {
    Navbar,
    FooterComponent,
  },
};
</script>
